import React from "react";
import { Typography } from "@material-ui/core";
import mergeClasses from "classnames";
import DataTable from "Components/Shared/DataTable/DataTable";
import DataTableRow from "Components/Shared/DataTable/DataTableRow/DataTableRow";
import useStyles from "./styles";

export interface FileSummaryTableProps {
  lineCount?: number;
  employeeCount?: number;
  missingEmployeeCount?: number;
  missingNetPayCount?: number;
  duplicateEmployeeCount?: number;
  duplicateLineCount?: number;
}

export const FileSummaryTable = ({
  lineCount,
  employeeCount,
  missingEmployeeCount,
  missingNetPayCount,
  duplicateEmployeeCount,
  duplicateLineCount,
}: FileSummaryTableProps) => {
  const classes = useStyles();

  return (
    <DataTable title="File Summary">
      <DataTableRow>
        <Typography>Lines</Typography>
        <Typography>{lineCount}</Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Employees</Typography>
        <Typography>{employeeCount}</Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Lines with missing employee ID</Typography>
        <Typography className={mergeClasses(missingEmployeeCount && classes.negativeValue)}>
          {missingEmployeeCount}
        </Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Lines with missing net pay</Typography>
        <Typography className={mergeClasses(missingNetPayCount && classes.negativeValue)}>
          {missingNetPayCount}
        </Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Lines with duplicated employee ID</Typography>
        <Typography className={mergeClasses(duplicateEmployeeCount && classes.negativeValue)}>
          {duplicateEmployeeCount}
        </Typography>
      </DataTableRow>
      <DataTableRow>
        <Typography>Duplicate lines</Typography>
        <Typography className={mergeClasses(duplicateLineCount && classes.negativeValue)}>
          {duplicateLineCount}
        </Typography>
      </DataTableRow>
    </DataTable>
  );
};
